import React from 'react';

const LeftArrowIcon = (props) => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='left-arrow-icon/plus-32x32' fill='currentColor'>
          <path d='M31.106,15H3.278l8.325-8.293  c0.391-0.391,0.391-1.024,0-1.414c-0.391-0.391-1.024-0.391-1.414,0l-9.9,9.899c-0.385,0.385-0.385,1.029,0,1.414l9.9,9.9  c0.391,0.391,1.024,0.391,1.414,0c0.391-0.391,0.391-1.024,0-1.414L3.278,17h27.828c0.552,0,1-0.448,1-1  C32.106,15.448,31.658,15,31.106,15z' />
        </g>
      </g>
    </svg>
  );
};

export default LeftArrowIcon;
